import IframeActivity from "./IframeActivity";

export default function Banter() {
    return (
        <IframeActivity
            src="/activities/banter/index.html"
            title="The Unwritten Rules of Banter"
        />
    );
}